import React, { useState } from 'react';
import { Typography, Container, Paper, Grid } from '@mui/material';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import './App.css';
import { useTranslation } from 'react-i18next';

const TouristAccomondation = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [loadingStates, setLoadingStates] = useState({}); // Tracks loading state for each image
  const { t, i18n } = useTranslation();

  const images = [
    { src: '/TouristAccomondationImages/6c7d9917-2ff9-471e-b4c2-c23bdb5eddc5.jpeg' },
    { src: '/TouristAccomondationImages/78836613-6cbb-41d9-8a50-44340d044895.jpeg' },
    { src: '/TouristAccomondationImages/6a2bd580-8c15-43c7-985e-696a7e0d2484.jpeg' },
    { src: '/TouristAccomondationImages/6fe1dbd0-9833-4abc-8347-f869c2de0b36.jpeg' },
    { src: '/TouristAccomondationImages/758d31e0-06b0-47c3-9df6-d6352b635819.jpeg' },
    { src: '/TouristAccomondationImages/99330968-ac5e-4a20-a225-4d23bee9ae42.jpeg' },
  ];

  const newImages = [
    { src: '/TouristAccomondationImages/305401583.jpg' },
    { src: '/TouristAccomondationImages/305401729.jpg' },
    { src: '/TouristAccomondationImages/305401752.jpg' },
    { src: '/TouristAccomondationImages/305401760.jpg' },
    { src: '/TouristAccomondationImages/305401580.jpg' },
    { src: '/TouristAccomondationImages/305401700.jpg' },
  ];

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
  };

  const handleImageError = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
  };

  return (
    <>
      <Container maxWidth="xl" style={{ padding: '20px', marginTop: '-20px' }}>
        <Paper elevation={3} className="home-paper">
          <Typography
            variant="h6"
            style={{
              color: '#576a89',
              textAlign: 'left',
              marginBottom: '0px',
            }}
          >
            {t('Oreozili Luxury Residence')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Architect: Aristomenis Varoudakis')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Located in City Center, Chania, Greece')}
          </Typography>

          <Grid container spacing={4} style={{ marginTop: '10px' }}>
            {images.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <div style={{ position: 'relative', width: '100%', height: '300px' }}>
                  {loadingStates[index] !== false && (
                    <div className="loader" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                      <div className="spinner"></div>
                    </div>
                  )}
                  <img
                    className="fancy-image"
                    src={image.src}
                    alt={`TourAccom ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease-in-out',
                      display: loadingStates[index] === false ? 'block' : 'none',
                    }}
                    onClick={() => {
                      setPhotoIndex(index);
                      setLightboxOpen(true);
                    }}
                    onLoad={() => handleImageLoad(index)}
                    onError={() => handleImageError(index)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>

      {/* Repeat for Second Group */}
      <Container maxWidth="xl" style={{ padding: '20px', marginTop: '-40px' }}>
        <Paper elevation={3} className="home-paper">
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Kalypso Vacation Rooms')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Architect: Vasilios Protopapadakis')}
          </Typography>
          <Typography variant="h6" style={{ color: '#576a89', textAlign: 'left', marginBottom: '0px' }}>
            {t('Located in Palaiochora, Chania, Greece')}
          </Typography>

          <Grid container spacing={4} style={{ marginTop: '10px' }}>
            {newImages.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <div style={{ position: 'relative', width: '100%', height: '300px' }}>
                  {loadingStates[index + images.length] !== false && (
                    <div className="loader" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                      <div className="spinner"></div>
                    </div>
                  )}
                  <img
                    className="fancy-image"
                    src={image.src}
                    alt={`AdditionalTourAccom ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease-in-out',
                      display: loadingStates[index + images.length] === false ? 'block' : 'none',
                    }}
                    onClick={() => {
                      setPhotoIndex(index + images.length);
                      setLightboxOpen(true);
                    }}
                    onLoad={() => handleImageLoad(index + images.length)}
                    onError={() => handleImageError(index + images.length)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={[...images, ...newImages]}
        index={photoIndex}
        plugins={[Zoom]}
        zoom={{ maxZoomPixelRatio: 3, zoomInMultiplier: 1.5 }}
      />

      <a href={`/portfolio?lang=${i18n.language}`} className="return-to-portfolio-button">
        {t('Return to Portfolio')}
      </a>
    </>
  );
};

export default TouristAccomondation;